import React from 'react';
import {Create, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import ParkingVehicleFields from "./ParkingVehicleFields";

export const ParkingVehicleCreate = props => (
    <Create {...props}>
        <SimpleForm toolbar={<CustomToolbar/>} redirect="list">
            <Grid container spacing={8}>
                <ParkingVehicleFields/>
            </Grid>
        </SimpleForm>
    </Create>
);

export default ParkingVehicleCreate
